(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-header"] && !Shopify.designMode) return;
  try {
    
  function getCookie(cname) {
    let name = cname + "=";
    let ca = decodeURIComponent(document.cookie).split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) == 0) return c.substring(name.length);
    }
    return "";
  }

  function toggleHomepageHeader() {
    const homepageHeaderWithoutCookie = document.getElementById('homepage-header-without-cookie');
    const homepageHeaderWithCookie = document.getElementById('homepage-header-with-cookie');
    if (!homepageHeaderWithCookie || !homepageHeaderWithoutCookie) return;
    const hasCookie = getCookie('pinter_fp_hp') === 'false';
    homepageHeaderWithCookie.style.display = hasCookie ? 'block' : 'none';
    homepageHeaderWithoutCookie.style.display = hasCookie ? 'none' : 'block';
  }

  document.addEventListener('DOMContentLoaded', toggleHomepageHeader);
  // The theme editor redraws the section without a page load
  document.addEventListener('shopify:section:load', toggleHomepageHeader);

  } catch(e) { console.error(e); }
})();
})();
